<template>
 
  <div class="achi" style="width:auto;">
    <div class="achititle">承担项目</div>
    <div class="achititle2"><img src="../../assets/achi/icon_1.png"><span style="color: #1296db;">科研服务</span></div>
    <div class="achiitem" v-for="(item,index) in data1">
       <div  class="achiitem_part1">{{item.name}}</div>
       <div class="achiitem_part2">
        <div style="display:flex;">
          <img src="../../assets/hezuo.svg" alt="" style="width:2.2vh;height:2.2vh;">
          <div class="item_hezuo">合作单位：{{item.from}}</div>
        </div>
        <div style="display:flex;">
           <img src="../../assets/time.svg" alt="" style="width:2.2vh;height:2.2vh;">
          <div class="item_time" >{{item.time}}</div>
        </div>
       </div>
    </div>

    <div class="achititle2"><img src="../../assets/achi/icon_2.png"><span style="color: #0e932e;">国际合作</span></div>
    <div class="achiitem" v-for="(item,index) in data2">
      <div  class="achiitem_part1">{{item.name}}</div>
       <div class="achiitem_part2">
        <div style="display:flex;">
          <img src="../../assets/hezuo.svg" alt="" style="width:2.2vh;height:2.2vh;">
          <div class="item_hezuo">合作单位：{{item.from}}</div>
        </div>
        <div style="display:flex;">
           <img src="../../assets/time.svg" alt="" style="width:2.2vh;height:2.2vh;">
          <div class="item_time" >{{item.time}}</div>
        </div>
       </div>
    </div>

    <div class="achititle2"><img src="../../assets/achi/icon_3.png"><span style="color: #d81e06;">政府咨询</span></div>
    <div class="achiitem" v-for="(item,index) in data3">
      <div  class="achiitem_part1">{{item.name}}</div>
       <div class="achiitem_part2">
        <div style="display:flex;">
          <img src="../../assets/hezuo.svg" alt="" style="width:2.2vh;height:2.2vh;">
          <div class="item_hezuo">合作单位：{{item.from}}</div>
        </div>
        <div style="display:flex;">
           <img src="../../assets/time.svg" alt="" style="width:2.2vh;height:2.2vh;">
          <div class="item_time" >{{item.time}}</div>
        </div>
       </div>
    </div>

    <div class="achititle2"><img src="../../assets/achi/icon_4.png"><span style="color: #e16531;">企业咨询</span></div>
    <div class="achiitem" v-for="(item,index) in data4">
      <div  class="achiitem_part1">{{item.name}}</div>
       <div class="achiitem_part2">
        <div style="display:flex;">
          <img src="../../assets/hezuo.svg" alt="" style="width:2.2vh;height:2.2vh;">
          <div class="item_hezuo">合作单位：{{item.from}}</div>
        </div>
        <div style="display:flex;">
           <img src="../../assets/time.svg" alt="" style="width:2.2vh;height:2.2vh;">
          <div class="item_time" >{{item.time}}</div>
        </div>
       </div>
    </div>

    <div class="achititle2"><img src="../../assets/achi/icon_5.png"><span style="color: #597ef7;">企业研发</span></div>
    <div class="achiitem" v-for="(item,index) in data5">
      <div  class="achiitem_part1">{{item.name}}</div>
       <div class="achiitem_part2">
        <div style="display:flex;">
          <img src="../../assets/hezuo.svg" alt="" style="width:2.2vh;height:2.2vh;">
          <div class="item_hezuo">合作单位：{{item.from}}</div>
        </div>
        <div style="display:flex;">
           <img src="../../assets/time.svg" alt="" style="width:2.2vh;height:2.2vh;">
          <div class="item_time" >{{item.time}}</div>
        </div>
       </div>
    </div>

    <div class="achititle">论文、著作、专利和软件著作权</div>
    <div class="achiitem" style="height:4.4vh" v-for="(item,index) in data20">
      <div style="display:flex;flex-direction: column;">
        <div style="width:100%;text-align:left; line-height: 1.5;" @click="openpdf(item.doi)"><span style="font-size:2vh">{{item.title}}</span></div>
        <div style="width:100%;text-align:left; line-height: 1.5;" ></div>
      </div>
    </div>
    <div class="achiitem" style="height:4.4vh" v-for="(item,index) in data21">
      <div style="display:flex;flex-direction: column;">
        <div style="width:100%;text-align:left; line-height: 1.5;" ><span style="font-size:2vh">{{item.title}}</span></div>
        <div style="width:100%;text-align:left; line-height: 1.5;" ></div>
      </div>
    </div>

  </div>
</template>

<script>

export default {
  name: 'AchiView',
   components: {

  },
  data(){
    return{
      data1:[{
              "name": "鲁西北耕地土壤碳汇能力提升技术研发与示范",
              "from": "山东省地质调查院",
              "time": "2024-2025 年",
              "src":require("../../assets/achi/1_1.png")
              },
              {
              "name": "基于小麦降碳提质增产增效用微藻生物产品研制与示范",
              "from": "山东省科技厅",
              "time": "2023-2025 年",
              "src":require("../../assets/achi/1_2.png")
              },
              {
              "name": "中挪畜禽养殖甲烷排放现状与控制技术评价",
              "from": "中国环境科学研究院",
              "time": "2024-2025 年",
              "src":require("../../assets/achi/1_3.png")
              },
              {
              "name": "九江低碳稻油轮作技术研发与示范",
              "from": "九江市农业科学院",
              "time": "2024-2025 年",
              "src":require("../../assets/achi/1_4.png")
              },
              ],
      data2:[{
              "name": "中国茶叶碳中和项目",
              "from": "联合国粮农组织",
              "time": "2017-2018 年",
              "src":require("../../assets/achi/2_1.png")
              },
              {
              "name": "肯尼亚碳中和茶叶种植和生产",
              "from": "联合国粮农组织",
              "time": "2024-2026 年",
              "src":require("../../assets/achi/2_2.png")
              },],
      data3:[{
              "name": "安溪铁观音碳中和茶产品研发",
              "from": "安溪人民政府",
              "time": "2024-2027 年",
              "src":require("../../assets/achi/3_1.png")
              },
              {
              "name": "农业绿色低碳发展状况调查与指标体系研究",
              "from": "国家发展和改革委员会",
              "time": "2023 年",
              "src":require("../../assets/achi/3_2.png")
              },
              {
              "name": "绛县特色农产品碳足迹核算与碳中和路径探索",
              "from": "绛县人民政府",
              "time": "2022-2024 年",
              "src":require("../../assets/achi/3_3.png")
              },
              {
              "name": "成都农业产业碳达峰碳中和路径研究",
              "from": "成都市农业农村局",
              "time": "2022 年",
              "src":require("../../assets/achi/3_4.png")
              },],
      data4:[{
              "name": "农业农村减排固碳实施方案研究",
              "from": "国家节能中心",
              "time": "2022 年",
              "src":require("../../assets/achi/4_1.png")
              },
              {
              "name": "大麦种植碳足迹及低碳种植解决方案",
              "from": "江苏农垦麦芽有限公司",
              "time": "2023-2024 年",
              "src":require("../../assets/achi/4_2.png")
              },
              {
              "name": "低碳大麦种植示范与低碳潜力核算",
              "from": "江苏农垦麦芽有限公司",
              "time": "2024-2025 年",
              "src":require("../../assets/achi/4_3.png")
              },
              {
              "name": "山东德州国家农业科技园区周年碳足迹核算",
              "from": "德州地福来生物科技有限公司",
              "time": "2023-2024 年",
              "src":require("../../assets/achi/4_4.png")
              },],
      data5:[{
              "name": "微藻生物固碳智慧监测及核算方法研究",
              "from": "运城地福来生物科技发展有限公司",
              "time": "2023-2028 年",
              "src":require("../../assets/achi/5_1.png")
              },
              {
              "name": "地福来对稻田有机碳和温室气体排放影响",
              "from": "九江地福来农业科技发展有限公司",
              "time": "2022-2023 年",
              "src":require("../../assets/achi/5_2.png")
              },
              {
              "name": "山楂种植应用微藻生物产品固碳减排效果研究",
              "from": "运城地福来生物科技发展有限公司",
              "time": "2022-2023 年",
              "src":require("../../assets/achi/5_3.png")
              },
              {
              "name": "微藻生物产品生产过程全生命周期碳汇量监测与评价",
              "from": "微藻时代（南京）生物科学有限公司",
              "time": "2022 年",
              "src":require("../../assets/achi/5_4.png")
              }],
      data20:[
                {
                  "title":"Zhang Jingyu,Wang Yanqun, Li Yingchun, etal. 2025 Carbon emissions peak of China’s apple cultivation achieved in 2014: a comprehensive analysis and implications",
                  "doi":'/pdfs/Carbon emissions peak of China’s apple cultivation achieved in 2014 a comprehensive analysis and implications.pdf'
                },
                {
                "title": "Li Kuo, Zhao Mingyue, Li Yingchun, et al. 2024. Spatiotemporal Trends of the Carbon Footprint of Sugar Production in China",
                "doi": '/pdfs/Spatiotemporal Trends of the Carbon Footprint of Sugar Production in China.pdf',
                },
                {
                "title": "Liu Jialiang, Zhang Jingyu, Li Yingchun, et al. 2024. China’s mandarin and tangerine cultivation has not reached the carbon emissions peak",
                "doi": "/pdfs/China’s mandarin and tangerine cultivation has not reached China’s mandarin and tangerine cultivation has not reached.pdf"
                },
                {
                "title": "Ma Fen, Liyingchun, Han Xue, et al. 2024. Microalgae-based biofertilizer improves fruit yield and controls greenhouse gas emissions in a hawthorn orchard",
                "doi": "/pdfs/Microalgae-based biofertilizer improves fruit yield and controls greenhouse gas emissions yield and controls greenhouse gas emissions.pdf"
                },
                {
                "title": "He Mingbao, Li Yingchun, Zong Shixiang, et al. 2023. Life Cycle Assessment of Carbon Footprint of Green Tea Produced by Smallholder Farmers in Shaanxi Province of China",
                "doi": "/pdfs/Life Cycle Assessment of Carbon Footprint of Green tea.pdf"
                },
                {
                "title": "He Mingbao, Zong Shixiang, Li Yingchun, et al. 2022. Carbon footprint and carbon neutrality pathway of green tea in China",
                "doi": "/pdfs/Carbon footprint and carbon neutrality pathway of green tea in China.pdf"
                },
      
              ],
      data21:[          {
                "title": "韩欣怡，韩雪，李廷亮，李迎春，李阔.2024. 中国马铃薯分省碳足迹核算与减排策略研究 —— 基于生命周期评价法",
                "doi": ""
                },
                {
                "title": "李迎春、韩雪、李阔等，典型农产品碳氮足迹时空特征（上），2024，中国农业技术出版社，15.7 万字",
                "doi": ""
                },
                {
                "title": "许吟隆、李阔、马欣、李迎春等，Carbon neutral tea production in China-Three pilot case studies. 2021，FAO, 3 万字",
                "doi": ""
                },
                {
                "title": "发明专利，李迎春等，一种茶叶全生命周期的碳足迹核算方法及系统，ZL202211337485.4，2023 年",
                "doi": ""
                },
                {
                "title": "软件著作权，李迎春等，绿茶碳足迹核算系统，2023SR0129260，2023 年",
                "doi": ""
                }]

    }
  },
  mounted(){
    console.log(this.data20)
    // this.$router.push({path:'/pdfs',query:{pdfurl:''}})
  },
  methods:{
    openpdf(url){
      window.open(url)
    }
  }
}
</script>


<style>
.achi{
  padding: 4.4vh 17vh;
  background-color: #f0f0f4;
  width: auto !important;
}
.achiitem{
  display: flex;
  /* width: 100%; */
  flex-direction: column;

  background-color: #fff;
  margin-bottom: 2.2vh;
  margin-top: 2.2vh;
  border-radius: 2.2vh;
  padding: 2.2vh 5vh;
  
}
.achiitem_part1{
  font-size:2.4vh;
  font-weight:700;
  text-align: left;
  letter-spacing: 0.2vh
}
.achiitem_part2{
  margin-top: 1vh;
  display: flex;
  justify-content: space-between;
}
.achititle{
  font-size: 3.3vh;
  font-weight: 700;

}
.achititle2{
  display: flex;
  align-items: center;
}
.achititle2 img{
  width: 4vh;
  height: 4vh;
  margin-right: 1vh;
}
.achititle2 span{
  font-size: 2.4vh;
   text-align: left;
  font-weight: 700;
  color: #1296db;
}
.achiitem div{
  
  align-items: center;
    
  
}
.item_hezuo{
  left:0;
  bottom:0;
  font-size:2.2vh;
  letter-spacing: 0.1vh;
  margin-left: 0.5vh;
}
.item_time{
  right:0;
  bottom:0;
  font-size:2.2vh;
  letter-spacing: 0.1vh;
  margin-left: 0.5vh;
}

</style>